export enum VehicleType {
    TRUCK = 1,
    TRAILER = 2,
    VAN = 3,
    BUS = 4,
}
